import { render, staticRenderFns } from "./dogovor.vue?vue&type=template&id=5270fc7a&scoped=true&"
import script from "./dogovor.vue?vue&type=script&lang=js&"
export * from "./dogovor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270fc7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5270fc7a')) {
      api.createRecord('5270fc7a', component.options)
    } else {
      api.reload('5270fc7a', component.options)
    }
    module.hot.accept("./dogovor.vue?vue&type=template&id=5270fc7a&scoped=true&", function () {
      api.rerender('5270fc7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/dogovor/dogovor.vue"
export default component.exports